// extracted by mini-css-extract-plugin
module.exports = {"navContainer":"MobileNavigation_navContainer_3xx94","isOpen":"MobileNavigation_isOpen_12gEt","navLink":"MobileNavigation_navLink_w8Qn-","isBlue":"MobileNavigation_isBlue_2te94"};